import { useEffect, useState } from 'react'
import { getEventService } from '@/services/events/EventInstance'
import { EV_TC_STRING_READY } from './Sourcepoint'

type ConsentPayload = { tcString: string; tcfString: string }

export function useTcString() {
  const [tc, setTc] = useState<ConsentPayload | null>(null)
  const bus = getEventService()

  useEffect(() => {
    let unmounted = false

    // Immediate fetch in case CMP is already resolved
    window.__tcfapi?.('getTCData', 2, (tcData?: any, success?: boolean) => {
      if (unmounted) return
      const raw = success && tcData?.tcString ? tcData.tcString : ''
      if (raw) {
        setTc({ tcString: raw, tcfString: `consent=${raw}` })
      }
    })

    const onReady = (e: CustomEvent<ConsentPayload>) => {
      if (!unmounted) setTc(e.detail)
    }

    bus.on(EV_TC_STRING_READY, onReady as any)
    return () => {
      unmounted = true
      bus.off(EV_TC_STRING_READY, onReady as any)
    }
  }, [bus])

  return tc // { tcString, tcfString } or null
}
